import {OverlayTransition} from './OverlayTransition';
import {FadeAnimation} from '../animations/FadeAnimation';
import {GroupAnimation} from '../animations/GroupAnimation';

export class FadeTransition extends OverlayTransition {



    public before() {
        super.before();
        if (this.args.direction=='prev') {
            let zMax=this.getMaxZIndex(this.args.enter);
            this.args.leave.css('z-index',zMax+1);
        } else {
            let zMax=this.getMaxZIndex(this.args.leave);
            this.args.enter.css('z-index',zMax+1);
        }
    }

    public after() {
        super.after();
        if (this.args.direction=='prev') {
            this.args.leave.css('z-index','');
        } else {
            this.args.enter.css('z-index','');
        }
    }

    public play() {
        if (this.args.direction=='prev') {
            this.animation = new GroupAnimation(
                new FadeAnimation(this.args.leave).from(1).to(0),
            );
        } else {
            this.animation = new GroupAnimation(
                new FadeAnimation(this.args.enter).from(0).to(1)
            );
        }
        return super.play();
    }

}

export {};